import $ from 'jquery'
import html2Canvas from 'html2canvas'
import { sendPv, sendCl, sendPf } from '@/utils/logTrack'
import router from '@/router'
export default {
  data() {
    return {
      isGlmsShare: router.currentRoute?.value?.meta?.isGlmsShare, // glms分享
      shareConversationId: router.currentRoute?.value?.query.share_conversation_id, // glms分享的id
      markdownOptions: {
        markdownIt: {
          linkify: true,
          html: true
        },
        linkAttributes: {
          attrs: {
            target: '_blank',
            rel: 'noopener'
          }
        }
      },
      scrollTarget: '.session-block',
      limitLength: 20000,
      historyListLength: 50,
      timeInterval: 10,
      computedHgtDelay: 30,
      scrollBotmDelay: 50,
      html2CanvasConfig: {
        useCORS: true,
        letterRendering: true,
        scale: window.devicePixelRatio < 2 ? 2 : window.devicePixelRatio
      }
    }
  },
  methods: {
    async download(ref, options) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const params = Object.assign(this.html2CanvasConfig, options)
          html2Canvas(ref, params).then(canvas => {
            const dataURL = canvas.toDataURL('image/png')
            const creatDom = document.createElement('a')
            document.body.appendChild(creatDom)
            creatDom.href = dataURL
            creatDom.download = options.name
            creatDom.click()
            resolve()
          })
        }, 100)
      })
    },
    async htmlToImg(ref) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          html2Canvas(ref, this.html2CanvasConfig).then(canvas => {
            // const ctx = canvas.getContext('2d')
            // ctx.rotate((-20 * Math.PI) / 180)
            // ctx.fontSize = '15px'
            // ctx.fillStyle = 'rgba(255, 0, 0, 0.6)'
            // ctx.textAlign = 'center'
            // ctx.textBaseline = 'Middle'
            // ctx.fillText('测试测试测试测试测试测试', canvas.width / 3, canvas.height / 2)
            const dataURL = canvas.toDataURL('image/png')
            resolve(dataURL)
          })
        }, 100)
      })
    },
    // 考虑到其它模块之前用的是rem不符合自适应定高，也不能calc, 中途加vh又比较乱，js处理省事
    sessionBlockHeight() {
      // pc端不需要计算
      if (!this.isMobile) {
        // $('.session-block').css('height', '100%')
        return
      }
      setTimeout(() => {
        const windowH = $(window).innerHeight() || 0
        const sboxH = $('.search-box').innerHeight() || 0
        const headerH = $('header').innerHeight() || 0
        // const sessionH = $('.session-header-wrap').innerHeight() || 0
        const targetH = windowH - headerH - sboxH
        $('.session-block').innerHeight(Math.ceil(targetH))
        // $('.session-block').css({ 'padding-bottom': sboxH + headerH + 'px' })
        // this.scrollToBottom(this.scrollTarget)
      }, this.computedHgtDelay)
    },
    // 定位到底部
    scrollToBottom(s, ms = 0) {
      setTimeout(() => {
        const a = $(s)[0]
        if (!a) {
          return
        }
        const h = $(s)[0].scrollHeight
        if (ms) {
          $(s).animate({ scrollTop: h + 'px' }, ms)
        } else {
          $(s).scrollTop(h)
        }
        // $(s).animate({ scrollTop: h + 'px' }, 800)
      }, this.scrollBotmDelay)
    },
    // 模型导航栏和侧边栏的动态高
    modelNavigateHeight() {
      const winWidth = $(window).width()
      if (winWidth <= 768) {
        const winHeight = $(window).innerHeight() || 0
        const headerHeight = $('.header-bar').innerHeight() || 0
        const exitHeight = $('#exitpanel').innerHeight() || 0
        const addbtnHeight = $('#addsession').outerHeight() || 0
        const panelHeight = winHeight - headerHeight
        $('#modelnavigate').innerHeight(panelHeight)
        $('#sessionlist').innerHeight(panelHeight)
        $('#sessioncontent').innerHeight(panelHeight - exitHeight - addbtnHeight)
      } else {
        $('#modelnavigate').innerHeight(135)
        $('#sessionlist').innerHeight('100%')
      }
    },
    // 计算是否是移动端
    judgeIsMobile() {
      //
    },
    // 模型导航栏缩放
    navigateBoxWidth() {
      const winWidth = $(window).innerWidth()
      if (winWidth < 1480) {
        const s = Math.round((winWidth / 1680) * 100) / 100
        $('.pc-navigate-box').css({ transform: `scale(${s})` })
      } else {
        $('.pc-navigate-box').css({ transform: `scale(1)` })
      }
    },
    // 校验密码
    checkPwd(value) {
      return /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d||!|@|#|￥|%|&|*|（|）|—|+|~]{8,20}/.test(value)
    },
    // 拷贝
    copy(str, msg = '拷贝成功！') {
      this.$copyText(str)
        .then(() => {
          this.$message.success(msg)
        })
        .catch(err => {
          if (err) {
            console.log(err)
          }
          this.$message.error('拷贝失败！')
        })
    },
    // @TODO
    goToLogin2(msg) {
      this.sendPv({
        md: 'home',
        ct: 'go_login',
        ctvl: msg
      })
      const redirect = location.pathname + location.search
      if (location.pathname !== '/') {
        this.$router.replace({ path: '/', query: { redirect } })
        // window.location.href = 'https://bm.aminer.cn/home?status=true'
      }
    },
    // 去登录页
    goToLogin(msg) {
      return this.goToLogin2(msg)
    },
    // 普通跳转
    toPath(val) {
      if (val) {
        this.$router.push(val)
      }
    },
    sendPv,
    sendPf,
    sendCl
  }
}
